// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ukcQxn94Ou4nghiKCEM2{justify-content:center;width:100px;min-height:32px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tab": `ukcQxn94Ou4nghiKCEM2`
};
export default ___CSS_LOADER_EXPORT___;
